import { type TopbarProps } from '../constants/ui'
import { useNotificationInbox } from '../hooks/useNotifications'
import { NotificationBell } from './NotificationBell'
import '../styles/topbar.scss'

export function Topbar({ title, subtitle }: TopbarProps) {
  const inbox = useNotificationInbox()

  return (
    <header className="topbar">
      <div>
        <h1 className="topbar__title">{title}</h1>
        <p className="topbar__subtitle">{subtitle}</p>
      </div>
      <div className="topbar__actions">
        <NotificationBell
          items={inbox.items}
          unreadCount={inbox.unreadCount}
          loading={inbox.loading}
          error={inbox.error}
          ringing={inbox.ringing}
          onOpenItem={(item) => {
            void inbox.openNotification(item)
          }}
          onMarkAllRead={() => {
            void inbox.markAllRead()
          }}
        />
      </div>
    </header>
  )
}
